import { type LoaderFunctionArgs, redirect } from 'react-router';
import { getBatchMessagesMap } from '@/hooks/batch-message/use-get-batch-messages';
import ROUTES from '@/routes';

export const previewBatchMessageLoader = (args: LoaderFunctionArgs) => {
  const batchId = Number(args.params.batchId ?? 0);
  const message = getBatchMessagesMap()[batchId];
  if (!message) return redirect(ROUTES.MY.SETTINGS.MESSAGING.BATCH.$path());
  return message;
};
